<template>
  <div class="container" >
    <breadcrumb></breadcrumb>
    <div  v-if="errorFecha" class="alert alert-primary" role="alert">
      {{errorFecha}}
    </div>

    <div class="card card--white h-auto w-100 mb-3" v-if="!errorFecha && cartola && cartola.cantidad>0">
      <div class="card-header">
        <div class="d-flex bd-highlight">
          <div class="p-2 mt-2 flex-grow-1 bd-highlight">
            <h4 class="ficha-cliente__header">Cartola Mes periodo {{$route.query.desde | moment("D MMM YYYY")}} al {{$route.query.hasta | moment("D MMM YYYY")}}</h4>

          </div>
          <div class="p-2 ml-auto bd-highlight">
            <div class="dropdown">
              <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                Descargar informes y certificados
              </button>
              <ul class="dropdown-menu">
                <li><button class="dropdown-item download-button" v-for="mes in meses" :key="mes" v-on:click="link_trazabilidad(mes)">Informe trazabilidad {{mes| moment("MMMM YYYY")}}</button></li>
                <li><button class="dropdown-item download-button" v-for="mes in meses" :key="mes" @click="descargarCertificado('cr_santiago', extraerMes(mes))">Certificado de recepción Santiago {{mes| moment("MMMM YYYY")}}</button></li>
                <li><button class="dropdown-item download-button" v-for="mes in meses" :key="mes" @click="descargarCertificado('cr_temuco', extraerMes(mes))">Certificado de recepción Temuco {{mes| moment("MMMM YYYY")}}</button></li>
                <li><button class="dropdown-item download-button" v-for="mes in meses" :key="mes" @click="descargarCertificado('cr_puerto_montt', extraerMes(mes))">Certificado de recepción Puerto Montt {{mes| moment("MMMM YYYY")}}</button></li>
                <li v-if="$store.state.user.superusuario"><button class="dropdown-item download-button" v-for="mes in meses" :key="mes" @click="descargarCertificado('cr_enfaena', extraerMes(mes))">Certificado de recepción Enfaena {{mes| moment("MMMM YYYY")}}</button></li>
                <li><button class="dropdown-item download-button" v-for="mes in meses" :key="mes" @click="descargarCertificado('cg', extraerMes(mes))">Certificado de gestión {{mes| moment("MMMM YYYY")}}</button></li>
              </ul>
            </div>

            <span v-show="isDownloading">Procesando...</span>
          </div>
        </div>
        <div v-if="error" class="alert alert-warning" role="alert">{{error}}</div>
      </div>
      <div class="card-body">

        <div  v-if="isUpdating" class="alert alert-primary" role="alert">Cargando ... </div>
        <div class="row" v-if="cartola && chartdata">
          <div class="col">
            <pie-chart :chartdata="chartdata" :options="options" ></pie-chart>
          </div>
          <div class="col">
            <table class="table table--secondary">
              <thead>
                <tr>
                  <th>Tipo Residuos</th>
                  <th style="text-align:right">Cantidad Retiros</th>
                  <th style="text-align:right">Total (Kg)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in cartola.rows" v-bind:key="row.id">
                  <td>{{ row.nombre }}</td>
                  <td style="text-align:right"> {{ Number(row.cantidad).toLocaleString() }}</td>
                  <td style="text-align:right">{{ Number(row.peso).toLocaleString() }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <th></th>
                  <th style="text-align:right">{{ Number(cartola.total).toLocaleString() }}</th>
                </tr>
              </tfoot>
            </table>
            <h4>
              Total de Órdenes de Trabajo en el periodo: <b>{{cartola.cantidad}}</b>
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="card card--white h-auto w-100">
      <div class="card-header">
        <div class="d-flex bd-highlight">
          <div class="p-2 mt-2 flex-grow-1 bd-highlight">
            <h4 class="ficha-cliente__header">Órdenes de Trabajo del periodo {{$route.query.desde | moment("D MMM YYYY")}} al {{$route.query.hasta | moment("D MMM YYYY")}}</h4>
          </div>
          <div class="p-2 ml-auto bd-highlight">
            <a type="button" class="btn btn-primary" v-on:click="getBlob()" v-show="!isDownloading">
              <i class="fa fa-download"></i>  Descargar Órdenes de Trabajo
            </a>
          </div>
        </div>
      </div>
      <div class="card-body" >

        <div v-if="ordenes.length===0" class="alert alert-primary" role="alert">No hay Órdenes para el periodo seleccionado</div>
        <table class="table table--secondary" v-if="ordenes.length>0">
          <thead>
            <tr>
              <th>ID</th>
              <th>Tipo Operación</th>
              <th>Fecha</th>
              <th>Empresa Transporte</th>
              <th>Vehiculo</th>
              <th style="width:250px;">Productos</th>
              <th>Destino</th>
              <th colspan="3">Documentos</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="orden in ordenes" v-bind:key="orden.id">
              <td>#{{orden.id}}</td>
              <td>{{orden.tipo_operacion}}</td>
              <td>{{orden.dia_ejecucion | moment("D MMM YYYY")}}</td>
              <td>{{orden.transporte.empresa}}</td>
              <td>{{orden.transporte.vehiculo}}</td>
              <td>{{orden.productos}}</td>
              <td>{{orden.destinos}}</td>
              <td>
                <div class="dropdown dropdown__actions">
                  <button class="btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false" data-hover="dropdown">
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li v-for="archivo in orden.archivos" :key="archivo.id">
                      <a :href="archivo" target="_blank" class="dropdown-item" >{{get_tipo_from_url(archivo,orden.archivos)}}</a>
                    </li>

                    <li v-if="orden.archivos && orden.archivos.length===0">No hay documentos</li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import PieChart from '@/views/PieChart.vue'
import { utils } from '@/utils.js'
import XLSX from 'xlsx'
import Breadcrumb from '@/components/Breadcrumb.vue'

export default {
  name: 'Cartola',
  mixins: [utils],
  components: { PieChart, Breadcrumb },
  props: {
    msg: String
  },
  data () {
    return {
      urlCertificados: process.env.VUE_APP_BASEURL_MAIN,

      errorFecha: null,
      error: null,
      cartola: null,
      chartdata: null,
      meses: [],
      ordenes: [],
      options: {
        legend: {
          display: true
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        responsive: false,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex]
              var currentValue = dataset.data[tooltipItem.index]
              return currentValue + '%'
            }
          }
        }
      }
    }
  },
  watch: {
    '$route.query': function () {
      console.log(this.$route.params)
    }
  },
  methods: {
    format_data_pie_chart (data) {
      var sum = data.reduce((a, b) => {
        return a + b.peso * 1
      }, 0)
      var labels = []
      var valores = []
      data.forEach(function (d) {
        labels.push(d.nombre)
        valores.push(Math.round(d.peso / sum * 1000) / 10)
      })

      var chartdata = {
        labels: labels,
        datasets: [
          {
            borderColor: [
              '#A6CE76',
              '#725840',
              '#E0C605',
              '#545454',
              '#F73434'
            ],
            backgroundColor: [
              '#A6CE76',
              '#725840',
              '#E0C605',
              '#545454',
              '#F73434'
            ],
            data: valores
          }
        ]
      }
      return chartdata
    },

    search () {
      var self = this
      self.isUpdating = true
      if (!this.$route.params.id) {
        return
      }
      if (!Number.isInteger(this.$route.params.id)) { return }

      var url = `${process.env.VUE_APP_BASEURL_CMTR}/cmtr/datos_para_portal_cliente_registro/?direccion=${this.$route.params.id}&rango__gte=${this.$route.query.desde}&rango__lte=${this.$route.query.hasta}`
      console.log(url)
      axios.get(url).then(function (res) {
        self.isUpdating = false
        self.cartola = res.data
        self.chartdata = self.format_data_pie_chart(res.data.rows)
      })
    },

    link_trazabilidad (mes) {
      this.error = false
      this.isDownloading = true
      // var url = `${process.env.VUE_APP_BASEURL_CMTR}/cmtr/cmtr?solicitud__origen=${this.$route.params.id}&rango__gte=${this.$route.query.desde}&rango__lte=${this.$route.query.hasta}`
      var url = `${process.env.VUE_APP_BASEURL_CMTR}/cmtr/cmtr/?solicitud__origen=${this.$route.params.id}&mes=${mes}`
      axios.get(url, { responseType: 'arraybuffer' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'CMTR.pdf')
          document.body.appendChild(link)
          link.click()
          this.isDownloading = false
        }).catch(error => {
          console.log(error.response)
          this.isDownloading = false
          this.error = error.response.message
        })
    },
    get_tipo_from_url (url, archivos) {
      console.log(url)
      var tipo = url.split('/').slice(-1)[0].split('_')[0]
      var archivosDelMismoTipo = archivos.filter(u => { return tipo === u.split('/').slice(-1)[0].split('_')[0] })
      if (archivosDelMismoTipo.length > 1) {
        return tipo + ' #' + (archivosDelMismoTipo.indexOf(url) + 1)
      }
      return tipo
    },
    // get_url (archivos, name) {
    //   return archivos.filter(archivo => { return archivo.search(name) >= 0 }) || null
    // },

    get_ots () {
      if (!Number.isInteger(this.$route.params.id)) { return }

      var params = {
        direccion: this.$route.params.id,
        desde: this.$route.query.desde,
        hasta: this.$route.query.hasta,

        dia_agendada__lte: this.$route.query.hasta,
        dia_agendada__gte: this.$route.query.desde,
        solicitud__origen: this.$route.params.id,

        // solicitud__tipo_operacion__in: [5, 6]

      }

      var url = `${process.env.VUE_APP_API_MAIN}/portal/ordenes/`
      // var url = `${process.env.VUE_APP_BASEURL}/base/api/ordenes/`

      axios.get(url, { params: params },
        //       paramsserializer:function (params) {
        //   return qs.stringify (params, {arrayformat:"repeat"})
        //  }
      ).then(res => {
        this.ordenes = res.data
      })
    },
    s2ab () {
      // var wb = XLSX.utils.book_new()
      // wb.Props = {
      //   Title: 'SheetJS Tutorial',
      //   Subject: 'Test',
      //   Author: 'Red Stapler',
      //   CreatedDate: new Date(2017, 12, 19)
      // }
      // wb.SheetNames.push('Ordenes')

      // this.wsData = [['OT', 'Tipo Operación', 'Fecha', 'Empresa Transporte', 'Vehículo', 'Producto', 'Cantidad', 'Destino']]
      // this.ordenes.forEach(orden => {
      //   orden.otproductos.forEach(otproducto => {
      //     // this.wsData.push([orden.id, orden.tipo_operacion, orden.dia_ejecucion, orden.transporte.empresa, orden.transporte.vehiculo, otproducto.producto, otproducto.pesaje_oficial, otproducto.destino])
      //   })
      // })
      // console.table(this.wsData)
      // var ws = XLSX.utils.aoa_to_sheet(this.wsData)
      // wb.Sheets.Ordenes = ws
      // var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

      // var buf = new ArrayBuffer(wbout.length) // convert s to arrayBuffer
      // var view = new Uint8Array()
      // for (var i = 0; i < wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF // convert to octet
      // debugger
      // return buf

    },
    getBlob () {
      var wb = XLSX.utils.book_new()
      wb.Props = {
        Title: 'SheetJS Tutorial',
        Subject: 'Test',
        Author: 'Red Stapler',
        CreatedDate: new Date(2017, 12, 19)
      }
      wb.SheetNames.push('Ordenes Trabajo')
      // var wsData = [['hello', 'world']] // a row with 2 columns
      this.wsData = [['OT', 'Tipo Operación', 'Fecha', 'Empresa Transporte', 'Vehículo', 'Producto', 'Cantidad', 'Unidad', 'Destino']]
      this.ordenes.forEach(orden => {
        orden.otproductos.forEach(otp => {
          this.wsData.push([
            orden.id, orden.tipo_operacion, orden.dia_ejecucion, orden.transporte.empresa,
            orden.transporte.vehiculo, otp.producto, otp.pesaje_oficial, 'kg', otp.destino
          ])
        })
      })
      var ws = XLSX.utils.aoa_to_sheet(this.wsData)
      wb.Sheets['Ordenes Trabajo'] = ws
      var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

      var buf = new ArrayBuffer(wbout.length) // convert s to arrayBuffer
      var view = new Uint8Array(buf) // create uint8array as viewer
      for (var i = 0; i < wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF // convert to octet
      var blob = new Blob([buf], { type: 'application/octet-stream' })
      // var aaa = this.s2ab()
      // debugger
      // var blob = new Blob([aaa], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'dat.xls')
      document.body.appendChild(link)
      link.click()
    },

    dateRange (startDate, endDate) {
      var start = startDate.split('-')
      var end = endDate.split('-')
      var startYear = parseInt(start[0])
      var endYear = parseInt(end[0])
      var dates = []

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i !== endYear ? 11 : parseInt(end[1]) - 1
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0
        for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
          var month = j + 1
          var displayMonth = month < 10 ? '0' + month : month
          dates.push([i, displayMonth, '01'].join('-'))
        }
      }
      return dates
    },

    extraerMes (mes) {
      const listaFecha = mes.split('-')
      return `${listaFecha[0]}-${listaFecha[1]}`
    },

    descargarCertificado (typeCertificate, date) {
      this.error = false
      this.isDownloading = true
      const url = `${this.urlCertificados}/cmtr/certificate/${typeCertificate}?idAddress=${this.$route.params.id}&date=${date}`
      axios.get(url, { responseType: 'arraybuffer' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${typeCertificate}_${date}.pdf`)
          document.body.appendChild(link)
          link.click()
          this.isDownloading = false
        }).catch(error => {
          this.isDownloading = false

          const errores = {
            cr_santiago: `No existen registros de recepción de residuos en Planta Santa Isabel para el periodo ${date}`,
            cr_temuco: `No existen registros de recepción de residuos en Planta Lautaro para el periodo ${date}`,
            cr_puerto_montt: `No existen registros de recepción de residuos en Planta Puerto Montt para el periodo ${date}`,
            cr_enfaena: `No existen registros de recepción de residuos en Planta El Olivar para el periodo ${date}`,
            cg: `No existen registros de gestión de residuos para el periodo ${date}`
          }

          if (error.response.status === 404) {
            this.error = errores[typeCertificate] ?? 'Error desconocido'
          } else {
            this.error = `Información preliminar de la fecha: ${date} aun no se encuentra cerrada`
          }
        })
    },
  },
  mounted () {
    this.search()
    // if (this.validate_rango_fecha()) {
    // }
    this.get_ots()
    this.meses = this.dateRange(this.$route.query.desde, this.$route.query.hasta)
  }
}
</script>

<style scoped>
.download-button {
  outline: none;
}
</style>
